module.exports = __webpack_public_path__ + "img/dog.56b5d0cf.png";